export default __webpack_public_path__ + "static/iconography-image-k-9e42755c058687c35387683d4ab75fd6.png";